import React, { Component } from 'react';
import renderHTML from 'react-render-html';
import PostRelContent from './Postrel'
import SharepostContent from './Sharepost'
import VideoPlayer from './VideoPlayer';

// import { DFPSlotsProvider, AdSlot } from 'react-dfp';


class Itempost extends Component {
  constructor(props){
    super(props)
    this.state = {
      postObj:[],
      url:'',
      renderPlayer: false,
    }
  }

  componentDidMount(){
    this.setState({
      postObj: this.props.itemPost,
      url: this.props.urlact
    })

  }

  componentWillReceiveProps(next_props) {
    if(next_props.itemPost !== this.state.postObj){
      this.setState({
        postObj: next_props.itemPost,
        url: this.props.urlact
      })
    }
    this.state.postObj.map((item, i) => {
      if(next_props.countryString === 'INT'){
        if(item.tags.indexOf(26) !== -1){
          this.setState({
            renderPlayer: true,
          })
        }
      }

      if(next_props.countryString === 'VE'){
        if(item.tags.indexOf(28) !== -1){
          this.setState({
            renderPlayer: true,
          })
        }
      }

      if(next_props.countryString === 'US'){
        if(item.tags.indexOf(27) !== -1){
          this.setState({
            renderPlayer: true,
          })
        }
      }
      return true;
    })
  }

  render() {
    const data = this.state.postObj

    return (
      <div>
      {
        data.map((item, i) => {
          let videoJsOptions = {}
          if(item.video_field.indexOf('youtu.be') !== -1 || item.video_field.indexOf('youtube.com') !== -1){
            videoJsOptions = {
              autoplay: false,
              controls: true,
              aspectRatio: '16:9',
              sources: [{
                src: item.video_field,
                type: "video/youtube"
              }]
            }
          }

          if(item.video_field.indexOf('vimeo.com') !== -1){
            videoJsOptions = {
              autoplay: false,
              controls: true,
              aspectRatio: '16:9',
              sources: [{
                src: item.video_field,
                type: "video/vimeo"
              }]
            }
          }

          if(item.video_field.indexOf('.mp4') !== -1){
            videoJsOptions = {
              autoplay: false,
              controls: true,
              aspectRatio: '16:9',
              sources: [{
                src: item.video_field,
                type: "video/mp4"
              }]
            }
          }

          return (
            <div className="item-post-content" key={i}>
              <div className="title">{renderHTML(item.title.rendered)}</div>
              <div className="date-cont">
                <div className="date"><p>{item.datep_field}</p></div>
                <div className="social">
                  <ul>
                    <SharepostContent textShared={item.title.rendered} imgShared="" urlShared={item.link}/>
                  </ul>
                </div>
              </div>
              <div>
              { item.video_field.length > 0 && Object.keys(videoJsOptions).length > 0 && this.state.renderPlayer === true &&
                <div className="wrapper-player">
                  <div className="player-new">
                    <VideoPlayer { ...videoJsOptions } />
                  </div>
                </div>
              }

              { item.video_field.length > 0 && Object.keys(videoJsOptions).length === 0 && this.state.renderPlayer === true  &&
                <div className="wrapper-player">
                  <div className="player">
                    <iframe src={item.video_field} title={item.title.rendered} frameborder="0"></iframe>
                  </div>
                </div>
              }
              { item.video_field.length !== 0 && this.state.renderPlayer === false   &&
                <div>
                  { item.imgft_field.length > 0 &&
                    <img src={item.imgft_field} alt=""/>
                  }
                </div>
              }
              { item.video_field.length === 0 && this.state.renderPlayer === true  &&
                <div>
                  { item.imgft_field.length > 0 &&
                    <img src={item.imgft_field} alt=""/>
                  }
                </div>
              }
              { item.video_field.length === 0 && this.state.renderPlayer === false  &&
                <div>
                  { item.imgft_field.length > 0 &&
                    <img src={item.imgft_field} alt=""/>
                  }
                </div>
              }
              </div>
              <div>{renderHTML(item.content.rendered)}</div>
              <div className="row">
                <PostRelContent post={(item.porsrel)?item.porsrel :[] } />
              </div>
              {/* <DFPSlotsProvider dfpNetworkId='22167442'
                sizeMapping={ [ {viewport: [1024, 768], sizes:[[728, 90]]},
                                {viewport: [320, 400], sizes:[[320,50],[300,100]] },
                                {viewport: [750, 200], sizes:[[640,350],[640,100]] }] } collapseEmptyDivs={true}>
                <div className={`id-tag-${item.id}`}>
                  <AdSlot sizes={[[320, 50], [320, 100]]} adUnit="IVC/IVC_leaderlboard_3" />
                </div>
              </DFPSlotsProvider> */}
            </div>
          )
        })
      }
      </div>
    );
  }
}

export default Itempost



// WEBPACK FOOTER //
// ./src/Itempost.js